/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Wed Sep 06 2023
 **/

import { Properties } from "../../properties";

export function checkVersion({ allows, disallows, disallowCallback }: CheckVersionOptions) {
	const result: CheckVersion = {
		allowed: true
	};
	if (Properties.solution.length > 0) {
		if (allows) {
			result.allowed =
				(typeof allows === "string" && allows === Properties.solution) ||
				(Array.isArray(allows) && allows.includes(Properties.solution));
		}
		if (disallows) {
			result.allowed = !(
				(typeof disallows === "string" && disallows === Properties.solution) ||
				(Array.isArray(disallows) && disallows.includes(Properties.solution))
			);
			if (disallowCallback) {
				result.callback = disallowCallback;
			}
		}
		return result;
	}
	return result;
}

export default function useCheckVersion(options: CheckVersionOptions) {
	return checkVersion(options);
}
